// extracted by mini-css-extract-plugin
export default {"Tryon":"Tryon_Tryon__YZXF7","left":"Tryon_left__sam7j","wrapper":"Tryon_wrapper__pI970"};